module.exports = __webpack_public_path__ + "static/media/dhawa-phuket.afc623b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/partnerLogo/dhawa-phuket.svg
// module id = 552
// module chunks = 0